import React, { useState } from "react";
import { Collapse, makeStyles, ButtonBase, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

export default function Drawer({ title, itemsSelectedCount, children, rangeMinValue, rangeMaxValue, unit }) {
  const [isOpen, setIsOpen] = useState(
    title === "Apparence de l'appareil" || title === "Prix" || title === "Type de pose" ? true : false
  );
  const classes = useStyle();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className={classes.container}>
      <ButtonBase className={classes.button} onClick={() => setIsOpen((prev) => !prev)}>
        <div className={classes.titleContainer}>
          <Typography className={classes.title}>
            {title}
            {isMobile && (
              <>
                {itemsSelectedCount > 0 ? ` (${itemsSelectedCount})` : null}
                {rangeMinValue || rangeMaxValue ? ` (${rangeMinValue} - ${rangeMaxValue}${unit})` : null}
              </>
            )}
          </Typography>
          {!isOpen ? <ExpandLess /> : <ExpandMore />}
        </div>
      </ButtonBase>
      <Collapse in={isOpen}>{children}</Collapse>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    position: "relative",
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid #D7D7D7",
  },
  button: {
    width: "100%",
  },
  titleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    padding: "8px",
  },
  title: {
    color: "#3E3E3E",
    fontSize: "17px",
    fontWeight: "bold",
  },
}));
